module.exports = __webpack_public_path__ + "static/media/bohaterowie_matlandia.0fcd21f0.svg";